<template>
  <div class="container">
    <el-card shadow="never" class="card">
      <span>Trans#: {{ bid }}</span>
    </el-card>
    <el-card shadow="never" class="card" header="BASIC INFORMATION">
      <el-row :gutter="24">
        <el-col :span="8" class="fact-col">
          <span>Company Quantity：</span>
          <span>{{ detailDataInfo.total }}</span>
        </el-col>
        <el-col :span="8" class="fact-col">
          <span>Credit Category：</span>
          <span>{{ detailDataInfo.typeStr }}</span>
        </el-col>
        <el-col :span="8" class="fact-col">
          <span>CreditLine List：</span>
          <a href="javascript:void(0)" @click="handleDownload">
            {{ detailDataInfo.fileName }}
          </a>
        </el-col>
      </el-row>
      <!--      <customize-form-info-->
      <!--        ref="basicForm"-->
      <!--        :infoData="_basicData"-->
      <!--      ></customize-form-info>-->
    </el-card>
    <el-card shadow="never" class="card" header="COMMENTS">
      <customize-form ref="commentsForm" :schema="commentsModel">
        <template v-slot:fileListSlot v-if="attachments.length">
          <p class="fileItem" @click="fileClick(attachments[0])">
            {{ attachments[0].fileName }}
          </p>
        </template>
      </customize-form>
    </el-card>

    <div class="btnArea" v-if="isApprove === 1">
      <customize-button style="margin-right: 20px" @click="handleReject">
        Reject
      </customize-button>
      <customize-button type="primary" @click="handlePass" :loading="loading">
        Pass
      </customize-button>
    </div>
  </div>
</template>

<script>
import { handleAudit, downloadFile, getBatchDetail, getFile } from './api'
import mixins from '../mixins/mixins'

export default {
  name: 'audit-detail',
  mixins: [mixins],
  computed: {
    _basicData() {
      return this.basicData.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        return item
      })
    },
  },
  data() {
    const commentsModel = [
      {
        key: 'remark',
        label: '',
        type: 'textarea',
        value: '',
        disabled: false,
      },
    ]
    return {
      bid: this.$route.query.bpmId,
      basicData: [],
      commentsModel,
      curId: '',
      loading: false,
      isApprove: 0,
      attachments: [],
      detailDataInfo: {},
    }
  },
  mounted() {
    this._getDetail()
  },
  methods: {
    // get audit detail
    async _getDetail() {
      try {
        const detailData = await getBatchDetail(this.$route.query.bpmId)
        this.detailDataInfo = detailData
        this.curId = detailData.id
        this.isApprove = detailData.isApprove
        // 如果是manual approve 不能编写comments
        if (this.isApprove !== 1) {
          this.commentsModel = [
            {
              key: 'remark',
              label: '',
              type: 'textarea',
              value: '',
              disabled: true,
            },
          ]
        }
        const _basicData = []
        Object.keys(detailData).forEach(key => {
          if (key === 'total' || key === 'typeStr' || key === 'fileName') {
            _basicData.push({
              key: key,
              value: detailData[key],
            })
          }
        })
        this.basicData = _basicData
        this.attachments = detailData.attachments
        if (
          detailData.remark.includes('&gt;') ||
          detailData.remark.includes('&lt;')
        ) {
          detailData.remark = detailData.remark.replace(/&gt;/g, '>')
          detailData.remark = detailData.remark.replace(/&lt;/g, '<')
        }
        this.commentsModel = [
          {
            ...this.commentsModel[0],
            value: detailData.remark,
          },
        ]
      } catch (err) {
        console.error(err)
      }
    },
    async handleDownload() {
      try {
        await downloadFile(this.curId)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    async handleSubmit(status) {
      try {
        this.loading = true
        const params = {
          ack: status,
          id: this.curId,
          remark: this.$refs.commentsForm.getFormData().remark,
        }
        await handleAudit(params)
        this.loading = false
        this.$message.success('success')
        this.$router.push('/credit-management/credit-batch-request/home')
      } catch (err) {
        console.error(err)
      }
    },
    handleReject() {
      this.handleSubmit(3)
    },
    handlePass() {
      this.handleSubmit(2)
    },
    async fileClick(fileObj) {
      try {
        const params = {
          id: fileObj.id,
        }
        await getFile(params)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="less">
.container {
  width: 100%;
  .card {
    width: 100%;
    margin-bottom: 24px;
  }
  .btnArea {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }
  .fileItem {
    width: 700px;
    color: blue;
    cursor: pointer;
  }
}
</style>
